import React from 'react';
import ReactEcharts from 'echarts-for-react';
import * as echarts from 'echarts';

const BusisPieChart = () => {
  // Data for the business value components
  const data = [
    {
      value: 879892.05,
      name: 'Underlying Business Assets',
      itemStyle: {
        color: '#2F80F7' 
      }
    },
    {
      value: 1062619.72,
      name: 'Estimated Goodwill',
      itemStyle: {
        color: '#A3E566' 
      }
    }
  ];

  // Option for the pie chart
  const option = {
    title: {
      text: 'Business Value Components',
      subtext: 'Underlying Business Assets vs Estimated Goodwill',
      left: 'center',
      top: 'top',
      textStyle: {
        fontWeight: 'bold',
        fontSize: 16
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b}: ${c} ({d}%)'
    },
    series: [
      {
        name: 'Business Value',
        type: 'pie',
        radius: '50%',
        data: data,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  };

  return (
    <ReactEcharts
      option={option}
      echarts={echarts}
      style={{ height: '400px', width: '100%' }}
    />
  );
};

export default BusisPieChart;
